(function(angular){
    'use strict';

    var requestTemplateMaster = function($scope: any) {
        //to inform main-controller.js to update page title when Requests page is loaded
        $scope.container = {
            itemType: 'RequestTemplatesList'
        };
    };

    requestTemplateMaster.$inject = [
    '$scope'
    ];

    angular.module('onvio.documents').controller('requestTemplateMaster', requestTemplateMaster);
})((window as any).angular);
